<template>
  <button class="btn -stripped" @click="$emit('toggle')">
    <h3>
      <SvgComponent
        v-if="open"
        :icon="{name: 'Close'}"
        style="margin-top: -3px; margin-right: 9px;"
      />
      <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" v-if="!open" v-bind:style="'margin-top: -3px; margin-right: 9px;'" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12 11V9h2v2h2v2h-2v2h-2v-2H0v-2h12zM7 3V1h2v2h7v2H9v2H7V5H0V3h7z" fill="#1D1D1D" fill-rule="evenodd"/></svg>
      <span class="filter-toggler-text">{{label || this.insertString('ProductList', 'Filter')}}&nbsp;</span>
      <span v-if="totalFilters > 0" class="filter-toggler-text">({{totalFilters}})</span>
    </h3>
  </button>
</template>

<script>
import SvgComponent from '@/Scripts/components/shared/svg/Svg.vue';

export default {
  components: {
    SvgComponent
  },
  props: {
    open: Boolean,
    totalFilters: Number,
    label: String
  }
};
</script>
